import { TokenContentRelatedArticleType } from '@/lib/api/tokens/types';

import { fontStyles } from '@/styles/typography';

import { TextSkeleton } from '../../Skeleton';
import { RelatedArticleLink } from './RelatedArticleLink';

interface RelatedArticlesProps {
  relatedArticles: TokenContentRelatedArticleType[];
  isLoading: boolean;
}

export const TokenProfileRelatedArticles = ({
  relatedArticles,
  isLoading,
}: RelatedArticlesProps) => {
  return (
    <div className="flex flex-col pl-6 pr-0 pt-6 pb-6 tablet:p-8">
      <h2 className={fontStyles({ variant: 'H5', class: ['mb-6', 'block'] })}>Related Articles</h2>
      <div className="gap-3 p-4 min-h-fit max-h-fit flex relative overflow-x-scroll whitespace-nowrap [scroll-snap-type:x_mandatory] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden [&:not(:hover)::-webkit-overflow-scrolling]:[touch-action:auto] [&::-moz-scrollbar]:hidden [&:not(:hover)::-moz-scrollbar]:[touch-action:auto]">
        {isLoading ? (
          <>
            <TextSkeleton
              height={148}
              width={228}
              className="border-token-gray-400 border border-solid rounded-md"
            />
            <TextSkeleton
              height={148}
              width={228}
              className="border-token-gray-400 border border-solid rounded-md"
            />
            <TextSkeleton
              height={148}
              width={228}
              className="border-token-gray-400 border border-solid rounded-md"
            />
          </>
        ) : (
          relatedArticles.map(
            ({ id, src, imgSrc, title, subtitle }: TokenContentRelatedArticleType) => {
              return (
                <RelatedArticleLink
                  key={id}
                  href={src}
                  imgSrc={imgSrc}
                  title={title}
                  subtitle={subtitle}
                />
              );
            },
          )
        )}
      </div>
    </div>
  );
};
